import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import moment from "moment";
import Modal from "./Modal";
import LoadingScreen from "./LoadingScreen";
import CopyRight from "./CopyRights";
import aboutmesvg from "../icons/aboutme-ico.svg";
import moresvg from "../icons/more-ico.svg";
import "./Home.css";

const Home = () => {
  const [latestDrawingProjects, setDrawingProject] = useState([]);
  const [latestUIUXProjects, setUIUXProject] = useState([]);
  const [latest3DProjects, set3DProject] = useState([]);
  const [latestITProjects, setITProject] = useState([]);
  const [latestGameDevProjects, setGameDevProject] = useState([]);
  const [modalData, setModalData] = useState({}); // this use to get one drawing data to popup
  const [isModalOpen, setModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [dataLoaded, setDataLoaded] = useState(false); // To control animation finish

  const openModal = (projectData) => {
    setModalData(projectData);
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
  };

  useEffect(() => {
    const getLatestData = async () => {
      try {
        const drawingResponse = await axios.get("/api/project/getLatestDrawings/");
        setDrawingProject(drawingResponse.data.prj);

        const uiuxResponse = await axios.get("/api/project/getLatestUIUXProjects/");
        setUIUXProject(uiuxResponse.data.prj);

        const threeDResponse = await axios.get("/api/project/getLatest3DProjects/");
        set3DProject(threeDResponse.data.prj);

        const itResponse = await axios.get("/api/project/getLatestITProjects/");
        setITProject(itResponse.data.prj);

        const gameDevResponse = await axios.get("/api/project/getLatestAnimations/");
        setGameDevProject(gameDevResponse.data.prj);
      } catch (error) {
        console.log("☠️ Error Detected : ", error.message);
      } finally {
        setIsLoading(false);
        setDataLoaded(true);
      }
    };

    getLatestData();
  }, []);

  if (isLoading) {
    return <LoadingScreen isLoading={isLoading} dataLoaded={dataLoaded} />; // Render loading screen while data is being fetched
  }

  return (
    <div className="home-div">
      <div className="home-title">
        <div className="head-title">YASIRU PANDUKA</div>
        <div className="about-btn-div">
          <Link to="/about-me">
            <button className="about-btn" type="button">
              <img
                src={aboutmesvg}
                alt="about-icon"
                className="about-btn-ico"
              />
              About Me!
            </button>
          </Link>
        </div>
      </div>

      <div className="home-info-div">
        I'm an artist, 3D artist, programmer, and indie game developer who loves
        turning ideas into creative, interactive experiences. From designing
        smooth user interfaces to crafting immersive game worlds, I enjoy
        blending creativity with technology. I'm passionate about working on
        projects that not only inspire but also make a positive difference.
      </div>

      <div className="latest-projects-div">
        <div className="latest-title-btn-div">
          <div className="latest-title">Latest Drawings/Illustrations</div>
          <div className="btn-more-div">
            <Link to="/drawings">
              <button className="btn-more" type="button">
                <img src={moresvg} alt="more-icon" className="more-btn-ico" />
                More
              </button>
            </Link>
          </div>
        </div>
        <div className="latest-projects-cards">
          {latestDrawingProjects.map((drawingData) => (
            <div className="proj-card" key={drawingData._id}>
              <div className="proj-image-div">
                <img
                  src={drawingData.imgUrl}
                  alt="proj-image"
                  className="proj-image"
                  onClick={() => openModal(drawingData)}
                  data-bs-toggle="modal"
                  data-bs-target="#projectModal"
                />
              </div>
              <div className="proj-details-div">
                <div className="tooltip-text">{drawingData.projectTopic}</div>
                <div
                  className="proj-title"
                  onClick={() => openModal(drawingData)}
                  data-bs-toggle="modal"
                  data-bs-target="#projectModal"
                >
                  {drawingData.projectTopic}
                </div>
                <div className="proj-created-date">
                  {moment(drawingData.createdAt).format(
                    "MMMM Do YYYY | h:mm a"
                  )}
                </div>
                <div className="proj-created-date">
                  {moment(drawingData.createdAt, "YYYYMMDD").fromNow()}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="latest-projects-div">
        <div className="latest-title-btn-div">
          <div className="latest-title">Latest UI/UX Designs</div>
          <div className="btn-more-div">
            <Link to="/ui-ux">
              <button className="btn-more" type="button">
                <img src={moresvg} alt="more-icon" className="more-btn-ico" />
                More
              </button>
            </Link>
          </div>
        </div>
        <div className="latest-projects-cards">
          {latestUIUXProjects.map((uiData) => (
            <div className="proj-card" key={uiData._id}>
              <div className="proj-image-div">
                <img
                  src={uiData.imgUrl}
                  alt="proj-image"
                  className="proj-image"
                  onClick={() => openModal(uiData)}
                  data-bs-toggle="modal"
                  data-bs-target="#projectModal"
                />
              </div>
              <div className="proj-details-div">
                <div className="tooltip-text">{uiData.projectTopic}</div>
                <div
                  className="proj-title"
                  onClick={() => openModal(uiData)}
                  data-bs-toggle="modal"
                  data-bs-target="#projectModal"
                >
                  {uiData.projectTopic}
                </div>
                <div className="proj-created-date">
                  {moment(uiData.createdAt).format("MMMM Do YYYY | h:mm a")}
                </div>
                <div className="proj-created-date">
                  {moment(uiData.createdAt, "YYYYMMDD").fromNow()}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="latest-projects-div">
        <div className="latest-title-btn-div">
          <div className="latest-title">Latest 3D Works</div>
          <div className="btn-more-div">
            <Link to="/3d-works">
              <button className="btn-more" type="button">
                <img src={moresvg} alt="more-icon" className="more-btn-ico" />
                More
              </button>
            </Link>
          </div>
        </div>
        <div className="latest-projects-cards">
          {latest3DProjects.map((l3dData) => (
            <div className="proj-card" key={l3dData._id}>
              <div className="proj-image-div">
                <img
                  src={l3dData.imgUrl}
                  alt="proj-image"
                  className="proj-image"
                  onClick={() => openModal(l3dData)}
                  data-bs-toggle="modal"
                  data-bs-target="#projectModal"
                />
              </div>
              <div className="proj-details-div">
                <div className="tooltip-text">{l3dData.projectTopic}</div>
                <div
                  className="proj-title"
                  onClick={() => openModal(l3dData)}
                  data-bs-toggle="modal"
                  data-bs-target="#projectModal"
                >
                  {l3dData.projectTopic}
                </div>
                <div className="proj-created-date">
                  {moment(l3dData.createdAt).format("MMMM Do YYYY | h:mm a")}
                </div>
                <div className="proj-created-date">
                  {moment(l3dData.createdAt, "YYYYMMDD").fromNow()}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="latest-projects-div">
        <div className="latest-title-btn-div">
          <div className="latest-title">Latest IT Projects</div>
          <div className="btn-more-div">
            <Link to="/it-projects">
              <button className="btn-more" type="button">
                <img src={moresvg} alt="more-icon" className="more-btn-ico" />
                More
              </button>
            </Link>
          </div>
        </div>
        <div className="latest-projects-cards">
          {latestITProjects.map((itData) => (
            <div className="proj-card" key={itData._id}>
              <div className="proj-image-div">
                <img
                  src={itData.imgUrl}
                  alt="proj-image"
                  className="proj-image"
                  onClick={() => openModal(itData)}
                  data-bs-toggle="modal"
                  data-bs-target="#projectModal"
                />
              </div>
              <div className="proj-details-div">
                <div className="tooltip-text">{itData.projectTopic}</div>
                <div
                  className="proj-title"
                  onClick={() => openModal(itData)}
                  data-bs-toggle="modal"
                  data-bs-target="#projectModal"
                >
                  {itData.projectTopic}
                </div>
                <div className="proj-created-date">
                  {moment(itData.createdAt).format("MMMM Do YYYY | h:mm a")}
                </div>
                <div className="proj-created-date">
                  {moment(itData.createdAt, "YYYYMMDD").fromNow()}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="latest-projects-div">
        <div className="latest-title-btn-div">
          <div className="latest-title">Latest Game Dev Works</div>
          <div className="btn-more-div">
            <Link to="/game-dev-works">
              <button className="btn-more" type="button">
                <img src={moresvg} alt="more-icon" className="more-btn-ico" />
                More
              </button>
            </Link>
          </div>
        </div>
        <div className="latest-projects-cards">
          {latestGameDevProjects.map((gameDevData) => (
            <div className="proj-card" key={gameDevData._id}>
              <div className="proj-image-div">
                <img
                  src={gameDevData.imgUrl}
                  alt="proj-image"
                  className="proj-image"
                  onClick={() => openModal(gameDevData)}
                  data-bs-toggle="modal"
                  data-bs-target="#projectModal"
                />
              </div>
              <div className="proj-details-div">
                <div className="tooltip-text">{gameDevData.projectTopic}</div>
                <div
                  className="proj-title"
                  onClick={() => openModal(gameDevData)}
                  data-bs-toggle="modal"
                  data-bs-target="#projectModal"
                >
                  {gameDevData.projectTopic}
                </div>
                <div className="proj-created-date">
                  {moment(gameDevData.createdAt).format(
                    "MMMM Do YYYY | h:mm a"
                  )}
                </div>
                <div className="proj-created-date">
                  {moment(gameDevData.createdAt, "YYYYMMDD").fromNow()}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <Modal isOpen={isModalOpen} onClose={closeModal} modalData={modalData} />

      <CopyRight />
    </div>
  );
};

export default Home;
